// extracted by mini-css-extract-plugin
export default {"settingsTab":"SettingsTab_settingsTab__ENsk6"};